import React, { useState, useEffect } from 'react';
import { Container, Table, Form, Card, Image } from 'react-bootstrap';
import { apiFetch, API_URL } from '../../../utils/api.js';

export function AdminShowcase() {
  const [cards, setCards] = useState([]);

  const fetchCards = async () => {
    const res = await apiFetch('/api/cards');
    const data = await res.json();
    setCards(data);
  };

  useEffect(() => { fetchCards(); }, []);

  const handleToggle = async (id) => {
    const res = await apiFetch(`/api/cards/${id}/toggle-featured`, { method: 'PATCH' });
    if (res.ok) {
      fetchCards(); // Обновляем список
    }
  };

  return (
    <Container>
      <div className="mb-4">
        <h2 className="fw-bold">Услуги на главной</h2>
        <p className="text-muted">Выберите услуги, которые будут отображаться в карусели на главной странице.</p>
      </div>

      <Card className="border-0 shadow-sm">
        <Table hover responsive className="m-0 align-middle">
          <thead className="bg-light">
            <tr>
              <th className="px-4 py-3">Фото</th>
              <th className="py-3">Название</th>
              <th className="py-3 text-center">На главной?</th>
            </tr>
          </thead>
          <tbody>
            {cards.map(card => (
              <tr key={card.card_id}>
                <td className="px-4 py-2">
                  <Image src={`${API_URL}/${card.image}`} width="50" height="50" className="rounded object-fit-cover" />
                </td>
                <td className="fw-medium">{card.title}</td>
                <td className="text-center">
                  <Form.Check 
                    type="switch"
                    id={`custom-switch-${card.card_id}`}
                    checked={card.is_featured}
                    onChange={() => handleToggle(card.card_id)}
                    className="d-inline-block custom-switch"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </Container>
  );
}
